import React, { useState } from "react";
import { f7, Page, Input, Button, Link } from "framework7-react";
import axios from 'axios';
import { API_BASE_URL, API_AUTH } from './../globals';
// import logo from '../../src/img/logo/eatbids-sm-logo.png';

const PageRegister = () => {
  const [rest_email, setEmail] = useState('');
  const [rest_password, setPassword] = useState('');
  const [rest_name, setRestName] = useState('');
  const [rest_ein, setEIN] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const eatBidsLogo = require('./../images/logo/eatbids-logo.png');

  const handleRegister = async (e) => {
    e.preventDefault();

    // Prevent multiple submissions while the registration is in progress
    if (isSubmitting) {
      return;
    }
    
    setIsSubmitting(true); // Disable the button

      const data = {
        rest_email:rest_email,
        rest_password: rest_password,
        rest_name: rest_name,
        rest_ein:rest_ein
      }
      axios.post(API_BASE_URL + 'restsignup', data,{ 
        headers:{
        'Authorization': 'Basic ' + API_AUTH
      }

     }).then(response=>{
      if(response.data.status ==="success"){
        localStorage.setItem('id', response.data.message.rest_id);
        localStorage.setItem('token', response.data.message.token);
        localStorage.setItem('auth', true);
        f7.views.main.router.navigate('/otpverify/');
      }else{
        f7.toast.create({
          text: "something went wrong",
          position: 'top',
          cssClass: 'bg-color-red',
          closeTimeout: 2000
        }).open()

      }

     }).catch(error => {
      const restEinError = error.response.data.message.rest_id;
      const restEmailError = error.response.data.message.rest_email;
      const restPassword = error.response.data.message.rest_password;
      let errorMessage = '';

      if (restEinError) {
        errorMessage += restEinError + '\n';
      }
      if (restPassword) {
        errorMessage += restPassword + '\n';
      }
      if (restEmailError) {
        if (errorMessage) {
          errorMessage += restEmailError + '\n'; // Add a space separator if restEinError exists
        }
        errorMessage += restEmailError + '\n';
      }
      console.error(error.response.data.message);
      f7.toast.create({
        text: errorMessage,
        position: 'top',
        cssClass: 'bg-color-red',
        closeTimeout: 2000
      }).open()
     })
     .finally(() => {
      setIsSubmitting(false); // Re-enable the button after registration attempt
    });
  };

  const imageUrl = 'https://www.eatbids.com/admin/assets/images/apps/eatbids-banner-pic.jpg'; // Replace with your image URL

  const BannerCover = {
    backgroundImage: `url(${imageUrl})`, // Set the background image URL
    backgroundRepeat: 'no-repeat', // Optional: Set background-repeat property
    backgroundSize: 'cover', // Optional: Set background-size property
    backgroundPosition: 'center', // Optional: Set background-position property
    // width: '300px', // Set the width of the container
    // height: '200px', // Set the height of the container
  };

  // const backgroundColor = 'rgba(255, 255, 0, 0.5) !important'; // Red background with 50% transparency
  const backgroundColor = 'rgba(255, 255, 255, 0.5)';

  const divTransparent = {
    background: backgroundColor, // Set the background color with transparency
  };

  const backgroundColor1 = 'rgba(255, 255, 255, 0.2)';

  const divTransparent1 = {
    background: backgroundColor1, // Set the background color with transparency
  };

  return (
    <Page noToolbar noNavbar noSwipeback loginScreen className='bg-white' style={BannerCover}>
      <section className="section-b-space pt-0" style={BannerCover}>
        <div className="container">
          <div className="row">
            <div className="col-sm p-0">
              {/* <img className="img-fluid login-img" src="https://themes.pixelstrap.com/zomo-app/assets/images/background/login-img.jpg" alt="login-img"/>
              <img className="img-fluid line-vector" src="https://themes.pixelstrap.com/zomo-app/assets/images/onboarding/line.png" alt="line" /> */}
            </div>
            <div className="col-sm p-0" style={divTransparent}> 
            {/* <div className="custom-logo-div d-none d-lg-block"> */}
              <div className="custom-logo-div">
                <div className="custom-logo">
                  <img class="img-fluid mb-3 mt-3 " src={eatBidsLogo} alt="eatBids" style={{width: "200px"}}/>
                </div>
              </div>
              <div className="custom-container" style={divTransparent1}>
                <form className="auth-form mt-5" onSubmit={handleRegister}>
                  <h2>Sign Up</h2>
                  <div className="form-group mt-4">
                    <label className="form-label fw-semibold dark-text">Email</label>
                    <div className="d-flex gap-3">
                      <div className="form-input dark-border-gradient">
                        <Input type="email" className="form-control" id="email" required validate onInput={(e) => { setEmail(e.target.value); }} placeholder="Enter Email Address" />                  
                      </div>
                    </div>
                  </div>
                  <div className="form-group mt-4">
                    <label className="form-label fw-semibold dark-text">Password</label>
                    <div className="d-flex gap-3">
                      <div className="form-input dark-border-gradient">
                        <Input type="password" className="form-control" id="password" required validate onInput={(e) => { setPassword(e.target.value); }} placeholder="Your password" />
                      </div>
                    </div>
                  </div>
                  <div className="form-group mt-4">
                    <label className="form-label fw-semibold dark-text">Restaurant Name</label>
                    <div className="d-flex gap-3">
                      <div className="form-input dark-border-gradient">
                        <Input type="text" className="form-control" id="name" required validate onInput={(e) => { setRestName(e.target.value); }} placeholder="Enter Restaurant Name" />                  
                      </div>
                    </div>
                  </div>
                  <div className="form-group mt-4">
                    <label className="form-label fw-semibold dark-text">EIN</label>
                    <div className="d-flex gap-3">
                      <div className="form-input dark-border-gradient">
                        <Input type="text" className="form-control" id="name" required validate pattern="^\d{2}-\d{7}$" errorMessage='Please check EIN format 00-0000000' placeholder="EIN Number"  onInput={(e) => { setEIN(e.target.value); }} />
                      </div>
                    </div>
                  </div>
                  {/* <Button type="submit" className="btn theme-btn w-100 mt-4" disable={isSubmitting} large role="button"  onClick={handleRegister}>Sign Up</Button> */}
                  <Button type="submit" className="btn theme-btn w-100 mt-4" large disabled={isSubmitting}>
                    {isSubmitting ? 'Signing Up...' : 'Sign Up'}
                  </Button>
                </form>
                {/* <div className="division">
                  <span>OR</span>
                </div> */}
                <p className="btn gray-btn mt-3 text-3"> Registered Member? <a href="/login/" className="text-black">Sign In</a></p>
                <p className="text-center1 text-2"><input type="checkbox" checked disabled className="mb-1 theme-deeporange"/> By continue, you agree to our Terms of service Privacy Policy Content Policy</p>
                <ul>
                  <li className="text-1">a. I am the rightful owner or representative of the contact information provided</li>
                  <li className="text-1">b. I accept Eatbids <Link href="https://www.eatbids.com/terms-and-conditions" target="_blank" external>Terms and Conditions</Link></li>
                  <li className="text-1">c. I opt-in to receive email and text communication from Eatbids</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Page>
  );
};

export default PageRegister;